/* atd-waitlist-info-modal.js — YouTube modal with scrollbar compensation */
(function () {
  const SELECTOR_PLAY = '.atd-waitlist-info__play';
  const MODAL_ROOT_ID = 'atd-waitlist-video-modal-root';
  const FOCUSABLE = 'a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])';

  function $(sel, root = document) { return root.querySelector(sel); }
  function $all(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }

  /* ---------- Scrollbar compensation (no layout shift) ---------- */
  const lockState = {
    locked: false,
    prev: { overflow: '', padRight: '' },
    sbw: 0
  };

  function getScrollbarWidth() {
    const w = window.innerWidth - document.documentElement.clientWidth;
    return w > 0 ? w : 0;
  }

  function lockScrollWithCompensation() {
    if (lockState.locked) return;

    const scrollEl = document.scrollingElement || document.documentElement;
    const html = document.documentElement;

    lockState.sbw = getScrollbarWidth();
    lockState.prev.overflow = scrollEl.style.overflow;
    lockState.prev.padRight = scrollEl.style.paddingRight;

    const currentPad = parseFloat(getComputedStyle(scrollEl).paddingRight || '0') || 0;

    if (lockState.sbw > 0) {
      scrollEl.style.paddingRight = (currentPad + lockState.sbw) + 'px';
      html.style.setProperty('--atd-sbw', lockState.sbw + 'px'); // optional CSS var
    }

    scrollEl.style.overflow = 'hidden';
    html.classList.add('atd-modal-open');

    // Optional: compensate fixed headers marked with data-avoid-shift
    document.querySelectorAll('[data-avoid-shift]').forEach((el) => {
      const prev = parseFloat(getComputedStyle(el).paddingRight || '0') || 0;
      el.dataset.prevPadRight = el.style.paddingRight || '';
      if (lockState.sbw > 0) el.style.paddingRight = (prev + lockState.sbw) + 'px';
    });

    lockState.locked = true;
  }

  function unlockScrollWithCompensation() {
    if (!lockState.locked) return;

    const scrollEl = document.scrollingElement || document.documentElement;
    const html = document.documentElement;

    scrollEl.style.overflow = lockState.prev.overflow || '';
    scrollEl.style.paddingRight = lockState.prev.padRight || '';
    html.style.removeProperty('--atd-sbw');
    html.classList.remove('atd-modal-open');

    document.querySelectorAll('[data-avoid-shift]').forEach((el) => {
      el.style.paddingRight = el.dataset.prevPadRight || '';
      delete el.dataset.prevPadRight;
    });

    lockState.locked = false;
  }

  /* ---------- YouTube helpers ---------- */
  function parseYouTubeId(url) {
    if (!url) return null;
    try {
      const u = new URL(url.value || url);
      if (u.hostname.includes('youtu.be')) return u.pathname.replace('/', '');
      if (u.searchParams.get('v')) return u.searchParams.get('v');
      const m = u.pathname.match(/\/embed\/([^/?#]+)/);
      return m ? m[1] : null;
    } catch {
      const raw = (url && (url.value || url)) || '';
      return /^[a-zA-Z0-9_-]{6,}$/.test(raw) ? raw : null;
    }
  }

  function buildModalHtml(embedSrc) {
    return `
      <div class="atd-video-modal" data-atd-modal role="dialog" aria-modal="true" aria-label="Video">
        <div class="atd-video-modal__backdrop" data-atd-close></div>
        <div class="atd-video-modal__dialog" role="document">
          <button type="button" class="atd-video-modal__close" aria-label="Close" data-atd-close>&times;</button>
          <div class="atd-video-modal__frame">
            <iframe
              class="atd-video-modal__iframe"
              src="${embedSrc}"
              title="YouTube video"
              allow="autoplay; encrypted-media; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    `;
  }

  /* ---------- Modal open/close ---------- */
  function openModal(youtubeUrl, openerBtn) {
    const id = parseYouTubeId(youtubeUrl);
    if (!id) return;

    const embed = `https://www.youtube.com/embed/${id}?autoplay=1&playsinline=1&rel=0&modestbranding=1`;
    const root = document.getElementById(MODAL_ROOT_ID);
    if (!root) return;

    root.innerHTML = buildModalHtml(embed);
    root.hidden = false;

    const modal = $('[data-atd-modal]', root);
    const closeEls = $all('[data-atd-close]', modal);

    // Lock scroll with gutter compensation
    lockScrollWithCompensation();

    // Focus handling
    const prevActive = document.activeElement;
    const closeBtn = $('.atd-video-modal__close', modal);
    if (closeBtn) closeBtn.focus();

    function cleanup() {
      root.hidden = true;
      root.innerHTML = '';
      unlockScrollWithCompensation(); // <- remove lock + padding

      if (openerBtn && document.body.contains(openerBtn)) openerBtn.focus();
      else if (prevActive) prevActive.focus();
      document.removeEventListener('keydown', onKeydown, true);
    }

    function onKeydown(e) {
      if (e.key === 'Escape') { e.preventDefault(); cleanup(); return; }
      if (e.key === 'Tab') {
        const focusables = $all(FOCUSABLE, modal).filter(el => el.offsetParent !== null);
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    closeEls.forEach(el => el.addEventListener('click', cleanup, { once: true }));
    document.addEventListener('keydown', onKeydown, true);

    // Safety hooks (BFCache / tab hide)
    window.addEventListener('pagehide', unlockScrollWithCompensation, { once: true });
    window.addEventListener('visibilitychange', () => {
      if (document.visibilityState !== 'visible') unlockScrollWithCompensation();
    }, { once: true });
  }

  /* ---------- Init ---------- */
  function init() {
    const btns = $all(SELECTOR_PLAY);
    if (!btns.length) return;
    btns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const url = btn.getAttribute('data-youtube-url');
        openModal(url, btn);
      });
    });

    /* Baseline modal styles (override in theme CSS if desired) */
    const css = `
      .atd-video-modal{position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center}
      .atd-video-modal__backdrop{position:absolute;inset:0;background:rgba(0,0,0,.6)}
      .atd-video-modal__dialog{position:relative;z-index:1;width:min(90vw,960px);aspect-ratio:16/9;background:#000;border-radius:12px;overflow:hidden;box-shadow:0 10px 40px rgba(0,0,0,.4)}
      .atd-video-modal__frame,.atd-video-modal__iframe{width:100%;height:100%;display:block;border:0}
      .atd-video-modal__close{position:absolute;top:8px;right:8px;width:40px;height:40px;border:0;border-radius:50%;background:#fff;color:#000;font-size:24px;cursor:pointer;z-index:2}
      .atd-modal-open{overflow:hidden}
      .atd-waitlist-info__play{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);display:grid;place-items:center;border:0;background:transparent;cursor:pointer}
    `;
    const style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
